import Vue from 'vue'
import VueI18n from 'vue-i18n'

import api from './api'

Vue.use(VueI18n)

const loadedLanguages = []
const messages = {}

const i18n = new VueI18n({
  locale: 'en-US',
  fallbackLocale: 'en-US',
  messages
})

function loadLocalMessages (lang) {
  try {
    const translations = require(`@/locales/${lang}.json`)
    return translations[lang]
  } catch (error) {
    return {}
  }
}

function setI18nLanguage (lang) {
  i18n.locale = lang
  document.querySelector('html').setAttribute('lang', lang)
  return lang
}

export function loadLanguageAsync (lang) {
  // If the same language
  if (i18n.locale === lang && loadedLanguages.includes(lang)) {
    return Promise.resolve(setI18nLanguage(lang))
  }

  // If the language was already loaded
  if (loadedLanguages.includes(lang)) {
    return Promise.resolve(setI18nLanguage(lang))
  }

  messages[lang] = loadLocalMessages(lang)

  api.i18NTranslation
    .fetchPage({
      pageSize: -1,
      page: 1,
      filters: [{ locale: { _eq: lang } }]
    })
    .then(({ items }) => {
      items.forEach(i => {
        if (!messages[i.locale]) messages[i.locale] = {}
        messages[i.locale][i.key] = i.translation
      })
      loadedLanguages.push(lang)
      return Promise.resolve(setI18nLanguage(lang))
    })
    .catch(err => {
      console.error(err)
    })
}

export default i18n
